<template>
  <div class="main-window-l">
    <div class="step-nav">
      <div class="nav-item active">
        行程管理
      </div>
    </div>

    <div class="center-pc">
      <div class="title">行程信息</div>
      <div class="list">
        <div class="centerItem">
          <label class="name">姓名</label>
          <label class="look">{{ detailForm.guestName }}</label>
        </div>
        <div class="centerItem" style="width: 100%">
          <label class="name">本人联系方式</label>
          <input id="oneselfMobile" v-model="formData.oneselfMobile" placeholder="请输入本人联系方式" class="txtin"
            maxlength="11" autocomplete="off" />
        </div>
        <div class="centerItem">
          <label class="name">来时班次</label>
          <input v-model="formData.pickUpTravelNumber" placeholder="请输入来时班次" class="txtin" autocomplete="off" />
        </div>
        <div class="centerItem">
          <label class="name">到达时间</label>
          <el-date-picker v-model="formData.pickUpDepartureTime" class="set-el" type="datetime" placeholder="到达时间"
            value-format="timestamp" prefix-icon="none" :clearable="false">
          </el-date-picker>
        </div>
        <div class="centerItem" style="width: 100%">
          <label class="name">到达站点</label>
          <select v-model="formData.pickUpDeparturePlace">
            <option v-for="(item, index) in siteOp" :key="index" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
        <div class="centerItem">
          <label class="name">离时班次</label>
          <input v-model="formData.dropOfTravelNumber" placeholder="请输入来时班次" class="txtin" autocomplete="off" />
        </div>
        <div class="centerItem">
          <label class="name">离时时间</label>
          <el-date-picker v-model="formData.dropOffArrivalTime" class="set-el" type="datetime" placeholder="到达时间"
            value-format="timestamp" prefix-icon="none" :clearable="false">
          </el-date-picker>
        </div>
        <div class="centerItem">
          <label class="name">离时站点</label>
          <select v-model="formData.dropOffArrivalDestination">
            <option v-for="(item, index) in siteOp" :key="index" :value="item">
              {{ item }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="foo">
      <div>
        <button class="leftBtn" @click="goBack">返回</button>
        <button class="rightBtn" @click="submit">提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { sessionData } from "@/static/js/local.js";
import { travelsDemand } from "@/api/trip";

export default {
  name: "trip_form",
  components: {},
  data() {
    return {
      siteOp: [
        "厦门高崎国际机场T3",
        "厦门高崎国际机场T4",
        "厦门北站",
        "厦门站",
      ],
      detailForm: {},
      formData: {},
    };
  },
  created() {
    if (!this.$cookies.isKey("token")) {
      this.$router.push("/login");
    }
    this.getList();
  },
  mounted() {
    this.detailForm = sessionData("get", "UserInfo");
  },
  methods: {
    getList() {
      travelsDemand
        .getList({
          page: {
            pageNum: 1,
            pageSize: 10,
          },
          mainId: this.$session.get("cmm").mainId,
        })
        .then((res) => {
          if (res && res.code === 200 && res.data.count > 0) {
            this.getDetail(res.data.result[0].id);
          }
        });
    },
    getDetail(id) {
      travelsDemand.detail(this.$session.get("cmm").mainId, id).then((res) => {
        if (res && res.code === 200) {
          this.formData = res.data;
        }
      });
    },
    goBack() {
      this.$router.push("/userIndex");
    },
    submit() {
      if (this.formData.oneselfMobile && !this.$isPhone(this.formData.oneselfMobile)) {
        this.$message("联系方式格式不正确");
        $("#oneselfMobile").focus();
        return false;
      }

      this.$msgbox({
        title: "确认信息",
        message: "确认提交该行程信息？",
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "cancel-btn-color",
        confirmButtonClass: "btn-color",
        callback: async (action, instance) => {
          if (action == "confirm") {
            let res;
            if (this.formData.id) {
              res = await travelsDemand.edit(this.formData);
            } else {
              res = await travelsDemand.add({
                ...this.formData,
                guestName: this.detailForm.guestName,
                mobile: this.detailForm.mobile,
                mainId: this.$session.get("cmm").mainId,
              });
            }
            if (res && res.code === 200) {
              this.$message.success("操作成功");
              setTimeout(() => {
                this.goBack();
              }, 500);
            }
          }
        },
      });
    },
  },
};
</script>

<style src="../../../static/css/regist.css" scoped></style>
<style src="../../../static/css/infoCommon.css" scoped></style>

<style scoped>
.list {
  overflow: hidden;
}

.list .centerItem {
  width: 45%;
  float: left;
}

.list .centerItem .name {
  width: 120px;
}
</style>
